import _ from 'lodash';

import Entity from './Entity';

import Invoice from './Invoice'

import featureFlags from '../featureFlags';


export const allowedManualPaymentTypes = [
  'CHECK',
  'CREDIT'
];


const paymentEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'PaymentTypeEnum' },
  credit_type_payment: { enumName: 'paymentTypeCreditEnum'}
};


export default class Payment {
  fields = {
    id: {
      value: null
    },
    credit_id: {
      value: null
    },
    type: {
      value: null
    },
    payment_meta: {
      value: null
    },
    amount: {
      value: null
    },
    created_at: {
      value: null
    },
    credit_entry: {
      value: null
    },
    credit: {
      value: null
    },
    invoice: {
      value: null
    },
    notes: {
      value: null
    },
  };


  static createFromQueryValues(values) {
    let payment = new this();

    for (let field in payment.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'created_at':
            payment.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          case 'invoice':
            payment.fields[field].value = (values[field] === null) ?
              values[field] :
              Invoice.createFromQueryValues(values[field]);
            break;  
          default:
            payment.fields[field].value = values[field];
        }
      }
    }

    return payment;
  }


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      paymentEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }


  static getPaymentAllocationTypes() {
    return new Promise((resolve, reject) => {
      Entity.getFieldAllowedValues(
        {},
        { allocation: { enumName: 'PaymentAllocationEnum' } },
        [ 'allocation' ]
      ).then(data => {
        resolve(data);
      }, error => {
        reject(error);
      });
    });
  }


  getAdminApplyPaymentQueryValues(invoiceId, allocationType, entries, overpaymentCredit) {
    const values = {
      invoice_id: invoiceId,
      payment: null,
      allocation: allocationType
    };
    if (featureFlags.OVERPAYMENT_PT2_I) {
      values.overpayment_credit = overpaymentCredit;
    }

    if (allocationType === 'PARTIAL_CUSTOM') {
      values.entries = Object.values(entries).reduce((queryValues, entry) => {
        if (entry.hasAmounts) queryValues.push(entry.getQueryFieldValues());
        return queryValues;
      }, []);
    }

    const paymentInput = _.cloneDeep(PaymentInput);
    paymentInput.amount = this.fields.amount.value;
    paymentInput.type = this.fields.type.value;
    paymentInput.payment_meta = this.fields.payment_meta.value;
    paymentInput.credit_id = this.fields.credit_id.value;
    values.payment = paymentInput;

    return values;
  }
}


export class PaymentEntryInput {
  fields = {
    line_item_id: {
      value: null
    },
    amount: {
      value: null
    },
    amount_tax_1: {
      value: null
    },
    amount_tax_2: {
      value: null
    },
    amount_tax_3: {
      value: null
    },
    amount_tax_4: {
      value: null
    }
  };

  get hasAmounts() {
    return this.fields.amount.value !== null ||
      this.fields.amount_tax_1.value !== null ||
      this.fields.amount_tax_2.value !== null ||
      this.fields.amount_tax_3.value !== null ||
      this.fields.amount_tax_4.value !== null
  }


  getQueryFieldValues() {
    const entryInput = _.cloneDeep(EntryInput);

    for (let field in entryInput) {
      entryInput[field] = this.fields[field].value || 0;
    }

    return entryInput;
  }
}


export const PaymentInput = {
  amount: null,
  type: null,
  payment_meta: null,
  credit_id: null,
  notes: null,
}


export const EntryInput = {
  line_item_id: null,
  amount: null,
  amount_tax_1: null,
  amount_tax_2: null,
  amount_tax_3: null,
  amount_tax_4: null
}
